module.exports = __webpack_public_path__ + "img/ao.52753def.svg";